/**
 * Use the DataStore to avoid making multiple requests to the same endpoints across different LCP components.
 */
export default class DataStore {
  constructor(boundaryId) {
    this.boundaryId = boundaryId
    this.data = {}
    this.queue = {}
  }

  get(type, onComplete) {
    // if data has already been loaded, return the loaded data (the point of this data store)
    if (this.data[type]) {
      return onComplete(this.data[type])
    }

    // if queue does not exist, create it and push the current onComplete function into it so we can process it when finished
    if (!this.queue[type]) {
      this.queue[type] = []
    }

    this.queue[type].push(onComplete)

    // if only one item is in the queue, this is the first time we're getting this data so go ahead and GET it otherwise will be processed via the queue when finished
    if (this.queue[type].length === 1) {
      switch (type) {
        case 'census':
          setTimeout(() => {
            fetch(
              `https://${
                process.env.REACT_APP_API_ENDPOINT || 'api.liveby.com'
              }/v1/pages/census?boundaryId=${encodeURIComponent(
                this.boundaryId
              )}`
            )
              .then((res) => res.json())
              .then((data) => {
                this.done(type, data)
              })
              .catch((err) => {
                this.data[type] = false
                console.error('Failed to get census data.')
                console.error(err)
              })
          }, 0)
          break
      }
    }
  }

  // process the queue and delete it after the data property has been updated with the data from the response and handlers have been executed
  done(type, data) {
    this.data[type] = data
    this.queue[type].forEach((onCompleteHandler) => {
      onCompleteHandler(data)
    })
    delete this.queue[type]
  }
}
